// extracted by mini-css-extract-plugin
module.exports = {"modal_2sfuGE":"modal_2sfuGE","header_2HK4oy":"header_2HK4oy","body_37a_tt":"body_37a_tt","footer_3e-xXL":"footer_3e-xXL","title_2wMYZO":"title_2wMYZO"};